import React, { useEffect, useState } from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import LoginPage from '../pages/LoginPage/LoginPage';
import HomePage from '../pages/HomePage/HomePage';
import DriverHomePage from '../pages/DriverHomePage/DriverHomePage';
import ManagerHomePage from '../pages/ManagerHomePage/ManagerHomePage';
import SalesHomePage from '../pages/SalesHomePage/SalesHomePage';
import CustomerHomePage from '../pages/CustomerHomePage/CustomerHomePage';
import AdminHomePage from '../pages/AdminHomePage/AdminHomePage';
import GeneralFinancePage from '../pages/GeneralFinancePage/GeneralFinancePage';
import RepairHomePage from '../pages/RepairHomePage/RepairHomePage';
import DoiMatKhauComponent from '../components/DoiMatKhauComponent/DoiMatKhauComponent';

const AppRoutes = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [loading, setLoading] = useState(true);  // Cờ để kiểm tra khi quá trình đăng nhập hoàn tất

  useEffect(() => {
    const userLoggedIn = localStorage.getItem('isLoggedIn'); 
    if (userLoggedIn === 'true') {
      setIsLoggedIn(true); 
    } else {
      setIsLoggedIn(false);
    }
    setLoading(false);  // Đặt loading thành false khi đã kiểm tra xong
  }, []);

  if (loading) {
    // Render một thành phần loading trong khi đang kiểm tra đăng nhập
    return <div>Loading...</div>;
  }

  return (
    <Routes>
      <Route path="/login" element={isLoggedIn ? <Navigate to="/" /> : <LoginPage setIsLoggedIn={setIsLoggedIn} />} />
      <Route path="/" element={isLoggedIn ? <HomePage /> : <Navigate to="/login" />} />
      <Route path="/drive" element={isLoggedIn ? <DriverHomePage setIsLoggedIn={setIsLoggedIn} /> : <Navigate to="/login" />} />
      <Route path="/manage" element={isLoggedIn ? <ManagerHomePage setIsLoggedIn={setIsLoggedIn} /> : <Navigate to="/login" />} />
      <Route path="/sale" element={isLoggedIn ? <SalesHomePage setIsLoggedIn={setIsLoggedIn} /> : <Navigate to="/login" />} />
      <Route path="/general_finance" element={isLoggedIn ? <GeneralFinancePage setIsLoggedIn={setIsLoggedIn} /> : <Navigate to="/login" />} />
      <Route path="/customer" element={isLoggedIn ? <CustomerHomePage setIsLoggedIn={setIsLoggedIn} /> : <Navigate to="/login" />} />
      <Route path="/admin" element={isLoggedIn ? <AdminHomePage setIsLoggedIn={setIsLoggedIn} /> : <Navigate to="/login" />} />
      <Route path="/repair" element={isLoggedIn ? <RepairHomePage setIsLoggedIn={setIsLoggedIn} /> : <Navigate to="/login" />} />
      <Route path="/change-password" element={isLoggedIn ? <DoiMatKhauComponent setIsLoggedIn={setIsLoggedIn} /> : <Navigate to="/login" />} />
    </Routes>
  );
};

export default AppRoutes;
